import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/access-management")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/_authenticated/access-management"!</div>;
}
